import { acceptInviteFunction } from "@diacare/common/actions/actions";
import { Card, HookForm, HookInputField, HookSubmitButton, showErrorToast, spacing } from "@litbase/alexandria";
import { client } from "@litbase/client";
import { useParams } from "react-router-dom";
import styled from "styled-components";

export function AcceptInvitePage() {
  const { token } = useParams();

  return (
    <Page>
      <h1>Meghívás elfogadása</h1>
      <StyledCard>
        <HookForm<{ password: string }>
          onSubmit={async (values) => {
            try {
              await client.call(acceptInviteFunction, token, values.password);
            } catch (e) {
              showErrorToast(<>Hiba történt!</>, <>{JSON.stringify(e)}</>);
            }
          }}
        >
          <HookInputField name="password" label="Kérjük adj meg egy tetszőleges jelszót!" type="password" />
          <HookSubmitButton>Meghívás elfogadása</HookSubmitButton>
        </HookForm>
      </StyledCard>
    </Page>
  );
}

const StyledCard = styled(Card)`
  max-width: 500px;
  width: 100%;
  button {
    margin-top: ${spacing._4};
  }
`;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
